<template>
  <CommonForm field-group="UsersNew" form-action="/markets/user" :is-visible-required="true" />
</template>

<script>
import CommonForm from '../../components/CommonForm'

export default {
  components: {
    CommonForm,
  },
}
</script>
